import LetsDialSocketClient from '@letsdial/socket/src/LetsDialSocketClient'
import { useAuthStore } from '/@/store/authStore'
import { Howl } from 'howler'
import LeadPop from '/@/assets/sounds/LeadPOP.ogg?url'
import { useCallStore } from '/@/store/callStore'
import { useChatStore } from '/@/store/chatStore'
import useLetsDialAPI from '../letsDialAPI/useLetsDialAPI'

const onUserChange = ({ status }) => {
  const store = useAuthStore()
  store.setStatus(status)
}

const onIncomingCall = (incomingCall) => {
  const socket = (useAuthStore() as any).socket // Fallback if needed, but usually passed
  const store = useCallStore()
  const authStore = useAuthStore()
  authStore.setAvailabilityStatus('RINGING')
  store.setIncomingCall(incomingCall)
  if (incomingCall.autoAnswer) {
    // Note: This relies on the socket being available. 
    // In this context, it's safer to use the global client or the one passed in.
  }
}

const onIncomingCallCancelled = () => {
  const store = useCallStore()
  const authStore = useAuthStore()
  authStore.setAvailabilityStatus('IDLE')
  store.setIncomingCall(undefined)
}

const onIncomingChatPrompt = (chat) => {
  const store = useChatStore()
  const authStore = useAuthStore()
  const beepVolume = authStore.user?.attributes?.additionalAttributes?.beepVolume ?? 0.05
  const sound = new Howl({
    src: [LeadPop],
    volume: beepVolume,
  })
  sound.play()
  authStore.setAvailabilityStatus('ON_LEAD')
  store.setIncomingChat(chat)
}

const onCallKilled = (event) => {
  const store = useCallStore()
  store.killCall(event.callID, event.killReason)
}

const onTransferIncoming = (incomingTransfer) => {
  const store = useCallStore()
  const authStore = useAuthStore()
  authStore.setAvailabilityStatus('RINGING')
  store.setIncomingTransfer(incomingTransfer)
}

export default function registerGlobalListeners(socket: LetsDialSocketClient) {
  // Unregister existing to prevent duplicates
  socket.off('user:change', onUserChange)
  socket.off('incoming:call', onIncomingCall)
  socket.off('incoming:call:cancelled', onIncomingCallCancelled)
  socket.off('incoming:chat:prompt', onIncomingChatPrompt)
  socket.off('call:killed', onCallKilled)
  socket.off('transfer:incoming', onTransferIncoming)

  // Register
  socket.on('user:change', onUserChange)
  socket.on('incoming:call', (incomingCall) => {
    onIncomingCall(incomingCall)
    if (incomingCall.autoAnswer) {
      socket.emit('user:accept:call', {
        callID: incomingCall.callID,
        accepted: true,
      })
      useCallStore().acceptIncomingCall()
    }
  })
  socket.on('incoming:call:cancelled', onIncomingCallCancelled)
  socket.on('incoming:chat:prompt', onIncomingChatPrompt)
  socket.on('call:killed', onCallKilled)
  socket.on('transfer:incoming', onTransferIncoming)
}
